module.exports = __webpack_public_path__ + "img/icon-search-white.1eecdfe9.svg";